// extracted by mini-css-extract-plugin
export var brand = "_b6-9";
export var compact = "_b6-6";
export var extraSmall = "_b6-7";
export var icon = "_b6-0";
export var large = "_b6-4";
export var light = "_b6-1";
export var medium = "_b6-5";
export var outline = "_b6-b";
export var primaryDark = "_b6-a";
export var primaryLight = "_b6-8";
export var primaryModern = "_b6-c";
export var success = "_b6-2";
export var successSolid = "_b6-3";